import React from 'react';
// Affiliate / partner program terms for Giga's referral program, operated by
// Tonic Labs Limited Adapted from the Reditus affiliate partner terms template and
// rebranded with Giga's program specifics: 20% commission, a 90-day referral
// cookie, and a 12-month commission period on eligible subscriptions.
// Rendered inside the dark marketing Layout, so it uses the same light-on-dark
// long-form document styling as the Terms of Service page.
// A numbered top-level article with a heading and body content.
function Article({
  n,
  title,
  children
}: {
  n: number;
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-5858" data-mp="1gy2bwlxoti22">
      <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-5859" data-mp="1gxir8xgnkfkc">
        {n}. {title}
      </h2>
      <div className="space-y-4" data-id="element-5860" data-mp="29fxv68shu34f">{children}</div>
    </section>;
}
export function AffiliateTerms() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-5861" data-mp="24phi4psl4jil">
      <p className="text-sm font-medium text-[#EA580C] mb-3 uppercase tracking-wider" data-id="element-5862" data-mp="24nwm0vqmgsim">
        Tonic Labs Limited · Giga Affiliate Partner Terms
      </p>
      <h1 className="text-4xl font-bold text-[#2B211A] mb-10 font-title tracking-tight" data-id="element-5863" data-mp="20xjlv68zp0ue">
        Affiliate Partner Terms
      </h1>

      <div className="space-y-10 text-neutral-700 font-body leading-relaxed text-[17px]" data-id="element-5864" data-mp="1n53s6w1zaf65">
        <section data-id="element-5865" data-mp="1r5w1fpauok2f">
          <p className="text-lg" data-id="element-5866" data-mp="1r5dxs7luz3kh">
            These are the terms and conditions applicable to (affiliate) partner
            agreements concluded and/or performed through the Reditus SaaS
            partner management platform, located at www.getreditus.com
            (hereinafter: &ldquo;Reditus&rdquo;), between online service
            provider <strong className="text-[#2B211A]" data-id="element-5867" data-mp="188318urm2o8q">Tonic Labs Limited</strong>
            , the company behind Giga (hereinafter referred to as
            &ldquo;Giga&rdquo;) and Reditus users intending to provide Giga with
            referral services.
          </p>
        </section>

        <Article n={1} title="Definitions" data-id="element-5868" data-mp="fdwpfaymufbf">
          <p data-id="element-5869" data-mp="fezj1qncavv1">
            The capitalized terms used in these Affiliate Partner Terms, both in
            the singular and the plural, are understood to have the meaning as
            described in this article.
          </p>
          <dl className="space-y-3" data-id="element-5870" data-mp="6di26623yq5a">
            <div data-id="element-5871" data-mp="1eeximq1ilxu">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5872" data-mp="1ex2q8uokahw">Account:</dt>{' '}
              <dd className="inline" data-id="element-5873" data-mp="y4xmtuk3u2sv">
                the account through which Partner and Giga access the Reditus
                platform.
              </dd>
            </div>
            <div data-id="element-5874" data-mp="u56rddjmuyi0">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5875" data-mp="pbuajpl73vzt">
                Affiliate Partner Terms:
              </dt>{' '}
              <dd className="inline" data-id="element-5876" data-mp="kc7z9loxgptn">
                the terms and conditions contained herein, as well as any
                annexes, which together form an integral part of the Partner
                Agreement.
              </dd>
            </div>
            <div data-id="element-5877" data-mp="1kctcbrq2axa7">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5878" data-mp="1kdcsb2w5jbll">
                Intellectual Property Rights:
              </dt>{' '}
              <dd className="inline" data-id="element-5879" data-mp="1pcfywrrs5pvo">
                all intellectual property rights and related rights, including
                but not limited to copyrights, database rights, domain name
                rights, trademark rights, brand rights, model rights,
                neighbouring rights, patent rights and rights to know-how.
              </dd>
            </div>
            <div data-id="element-5880" data-mp="28a0grew4no6s">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5881" data-mp="289h3wclc3pzm">Lead:</dt>{' '}
              <dd className="inline" data-id="element-5882" data-mp="2d2jqu1vlw16u">
                a potential customer directed to Giga&rsquo;s services by
                Partner as a result of Partner&rsquo;s performance of Referral
                Services, for example via a referral link or other agreed
                referral tools.
              </dd>
            </div>
            <div data-id="element-5883" data-mp="2r1jdx53h080w">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5884" data-mp="2qyx757oelwjq">
                Partner Agreement:
              </dt>{' '}
              <dd className="inline" data-id="element-5885" data-mp="29dhbaa6i1tld">
                an agreement between Partner and Giga, of which these Affiliate
                Partner Terms form an integral part, and under which Partner
                will provide the Referral Services. The Partner Agreement and
                these Affiliate Partner Terms applicable to it are offered
                independently by Giga.
              </dd>
            </div>
            <div data-id="element-5886" data-mp="1qf4zego7e5m3">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5887" data-mp="1qfo95a3p9np1">Partner:</dt>{' '}
              <dd className="inline" data-id="element-5888" data-mp="24envuc7njsik">
                a legal entity or natural person that uses the Reditus platform
                with the purpose of concluding and performing Partner Agreements
                in exchange for commission.
              </dd>
            </div>
            <div data-id="element-5889" data-mp="3auq5yv8zpdb3">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5890" data-mp="3at5b14irjscp">
                Partner Program:
              </dt>{' '}
              <dd className="inline" data-id="element-5891" data-mp="wkuon0cppt9u">
                Giga&rsquo;s offer, published on Reditus, for Partners to enroll
                in a partner program and thus conclude a Partner Agreement.
              </dd>
            </div>
            <div data-id="element-5892" data-mp="skkklt8hdcxm">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5893" data-mp="sk2du2o6zgbg">Party:</dt>{' '}
              <dd className="inline" data-id="element-5894" data-mp="1gaeuc1xi6ldn">
                Partner and Giga (plural), or either Partner or Giga (singular).
              </dd>
            </div>
            <div data-id="element-5895" data-mp="1kb8kl1yf4c9p">
              <dt className="font-semibold text-[#2B211A] inline" data-id="element-5896" data-mp="1kdumom2jhzkj">
                Referral Services:
              </dt>{' '}
              <dd className="inline" data-id="element-5897" data-mp="1bj6k53ocmvzf">
                referral services provided by the Partner to Giga in exchange
                for a commission in accordance with the Partner Agreement, as
                specified in Annex 1 to these Affiliate Partner Terms.
              </dd>
            </div>
          </dl>
        </Article>

        <Article n={2} title="Conclusion of the Partner Agreement" data-id="element-5898" data-mp="2duoib9qlxv44">
          <p data-id="element-5899" data-mp="28wwgno05uumq">
            A Partner Agreement is concluded by Partner&rsquo;s request to
            enroll in Giga&rsquo;s Partner Program, Partner&rsquo;s acceptance
            of these Affiliate Partner Terms, Annex 1 and (if provided and
            applicable) the additional terms and conditions contained in Annex 2
            to these Affiliate Partner Terms &ndash; and Giga&rsquo;s subsequent
            acceptance and confirmation of Partner&rsquo;s enrollment and of the
            conclusion of the Partner Agreement &ndash; all of which are
            performed and provided through Reditus. Upon conclusion of the
            Partner Agreement, Partner will be authorized to perform Referral
            Services on behalf of Giga, in accordance with the terms and
            conditions set out in the Partner Agreement.
          </p>
          <p data-id="element-5900" data-mp="1782parm1m7k1">
            The following order of precedence will apply in the event of
            inconsistencies between the applicable documents:
          </p>
          <ol className="list-decimal pl-5 space-y-2" data-id="element-5901" data-mp="3mvgb78awxen0">
            <li data-id="element-5902" data-mp="3my2n1k4u6gb1">(if applicable) the Additional Terms (Annex 2);</li>
            <li data-id="element-5903" data-mp="3rvuaa0ujde8w">the Referral Services and Variable Term Sheet (Annex 1);</li>
            <li data-id="element-5904" data-mp="nyloz1mput7">these Affiliate Partner Terms.</li>
          </ol>
          <p data-id="element-5905" data-mp="2z6nbd0r66mn4">
            Giga reserves the right to evaluate each application to enroll in
            the Partner Program. As a result, it may decide that it does not
            want to conclude a Partner Agreement, and thus reject the
            application, at its sole discretion.
          </p>
          <p data-id="element-5906" data-mp="3dv9sn80cxogz">
            The right to perform Referral Services for Giga is provided on a
            non-exclusive basis. Giga may engage other partners or affiliates
            for the performance of similar or identical activities and services,
            and will always remain entitled to perform such activities, and any
            other conceivable promotional activities by itself.
          </p>
          <p data-id="element-5907" data-mp="19td2eqad06wy">
            By entering into the Partner Agreement, the Parties will not
            (legally) form a partnership, general partnership, public
            partnership, joint venture or equivalent partnership. Neither Party
            will be authorized to enter into agreements on the other
            party&rsquo;s behalf.
          </p>
        </Article>

        <Article n={3} title="Obligations of the Partner" data-id="element-5908" data-mp="1xofr8y95yadf">
          <p data-id="element-5909" data-mp="1sqwg477ridpp">
            On conclusion of the Partner Agreement through Reditus, the Partner
            will gain access to functionalities and environments of the Reditus
            platform intended to facilitate and track the performance of
            Referral Services. The Partner ensures that its Account will not be
            shared with third parties.
          </p>
          <p data-id="element-5910" data-mp="2biyo6u6c8loc">
            Through Reditus, depending on the type of Referral Services agreed,
            Partner will be provided with tools, such as referral links, to
            perform the Referral Services.
          </p>
          <p data-id="element-5911" data-mp="302jw71qhnkza">Partner will:</p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-5912" data-mp="300pk8cx7337c">
            <li data-id="element-5913" data-mp="2l4rkylrz5iqw">
              adhere to all applicable laws and regulations in its performance
              of the Partner Agreement;
            </li>
            <li data-id="element-5914" data-mp="2cdhg3ybi606w">
              refrain from performing Referral Services via websites (or other
              channels) of an unlawful or illegal nature;
            </li>
            <li data-id="element-5915" data-mp="2h5iqfep41gua">
              refrain from performing Referral Services through electronic
              communication in a way that would constitute &lsquo;spam&rsquo;
              and is in violation of applicable law, such as the unsolicited
              performance of promotional activities through e-mail, SMS or a
              similar medium;
            </li>
            <li data-id="element-5916" data-mp="1xf5kluzv8xhb">
              follow reasonable recommendations and requests made by Giga with
              regard to its performance of the Referral Services;
            </li>
            <li data-id="element-5917" data-mp="1wn26zxxe20jp">
              refrain from distorting the tracking of the performance of the
              Referral Services by performing self-referrals;
            </li>
            <li data-id="element-5918" data-mp="1mocxasfnbmej">
              refrain from buying or bidding on keywords in Google Ads or doing
              the same with any similar service(s) from other providers for the
              same or similar purpose, consisting any parts of a tradename,
              service- or trademark, that belongs to Giga;
            </li>
            <li data-id="element-5919" data-mp="21mf2t868mhyf">
              refrain from search engine ads (especially on branded terms or
              domain names), Facebook ads or other ads that would compete with
              Giga&rsquo;s marketing and cause potential confusion for customers
              of Giga.
            </li>
          </ul>
          <p data-id="element-5920" data-mp="2y3rwm2vbuqct">
            Giga may provide Partner with promotional materials regarding
            Giga&rsquo;s services, which may be used by Partner in its
            performance of Referral Services. Partner is not entitled to alter
            such materials. If Partner opts to use such materials, it will at
            all times use the latest versions of the materials, information and
            pricing as provided by Giga from time to time.
          </p>
          <p data-id="element-5921" data-mp="3poo7nnjqhqo">
            Partner will inform and advise the parties it targets in its
            performance of Referral Services in an honest and sincere manner.
            Under no circumstances may Partner provide information concerning
            Giga or its services that could be misleading or would be difficult
            to prove. Partner will refrain from making any representation or
            promise that cannot be verified or that cannot be fulfilled by Giga.
          </p>
          <p data-id="element-5922" data-mp="1k3x1ermffepn">
            Giga may conduct a satisfaction research regarding Partner&rsquo;s
            (promotional) activities among Leads provided by Partner. For this
            purpose, Giga may request feedback from these Leads, and Partner
            will, insofar Giga deems it necessary, offer its reasonable
            cooperation and support in this regard. Giga may terminate the
            Partner Agreement with immediate effect when the research, according
            to Giga&rsquo;s reasonable opinion, shows that further affiliation
            with Partner will or might have a negative effect on Giga&rsquo;s
            reputation.
          </p>
          <p data-id="element-5923" data-mp="1dfzy2c6ys8j8">
            Any abuse of the tools provided to perform and/or track the Referral
            Services by the Partner will result in Giga&rsquo;s right to
            terminate the Partner Agreement with immediate effect without notice
            being required. Any rights of Partner accrued prior to the moment of
            termination for aforementioned reasons will lapse, unless Giga
            decides otherwise.
          </p>
        </Article>

        <Article n={4} title="Commission and payment" data-id="element-5924" data-mp="37ygwyehc2eno">
          <p data-id="element-5925" data-mp="33xwyn7l0x4zy">
            Depending on the type of Referral Services agreed between the
            Parties, Partner may, on the conditions specified in Annex 1 to
            these Affiliate Partner Terms, obtain the right to a certain amount
            of commission when a Lead undertakes certain actions with Giga, such
            as account registration or purchases.
          </p>
          <p data-id="element-5926" data-mp="2p2h30y4sp11g">
            Attribution of commission owed to Partner is reported and calculated
            automatically through the Reditus platform. Giga will maintain its
            use and implementation of the tools provided by the Reditus platform
            to this end for the full duration of the Partner Agreement.
          </p>
          <p data-id="element-5927" data-mp="26aehb8daqukc">
            Giga will pay the commission owed to Partner through the agreed
            payment method and in the agreed currency, specified in Annex 1 to
            these Affiliate Partner Terms. Partner is responsible for payment of
            any taxes applicable to the commission. The commission as paid out
            by Giga is considered to be inclusive of VAT and/or other levies.
            Any costs payable for the exchange of currency, as well as any other
            payment associated costs, are at the expense of Partner.
          </p>
          <p data-id="element-5928" data-mp="3imtiqqmy3uou">
            The frequency with which the commission will be paid out
            (hereinafter: &ldquo;Payment Period&rdquo;) is specified in Annex 1
            to these Affiliate Partner Terms. Payout will occur provided that
            the payment threshold specified in Annex 1 (hereinafter:
            &ldquo;Payment Threshold&rdquo;) is met.
          </p>
          <p data-id="element-5929" data-mp="3dptbiced0lw5">
            When the commission accrued during a Payment Period is less than the
            Payment Threshold, the accrued amount will be carried over to the
            following Payment Period until the Payment Threshold is met.
          </p>
          <p data-id="element-5930" data-mp="2wffw48y5ocoe">
            Giga will provide Partner with a specification of the commission due
            (or rolled over) at the end of each Payment Period. If the Payment
            Threshold is met, Giga will additionally issue a self-billed invoice
            on behalf of Partner. These may be made available within the Reditus
            portal. Partner is responsible for verifying the accuracy and
            completeness of the aforementioned specification and/or invoices.
            Giga must be notified of any errors or inconsistencies within one
            (1) week after the specification is issued, otherwise these will be
            deemed final and correct.
          </p>
        </Article>

        <Article n={5} title="Term and termination" data-id="element-5931" data-mp="3k4ian7xhtpeo">
          <p data-id="element-5932" data-mp="1uosrvfiu0959">
            The Partner Agreement will commence on the date of conclusion as
            indicated in Article 2 and will have an indefinite duration.
          </p>
          <p data-id="element-5933" data-mp="1psak06s7fuop">
            Both Parties are entitled to terminate the Partner Agreement without
            cause and with immediate effect, at any time, upon written notice to
            the other Party.
          </p>
          <p data-id="element-5934" data-mp="2nremw9rzbk7">
            Giga may terminate the Partner Agreement at any time by providing
            written notice to the Partner and paying a buyout fee to the Partner
            as specified in Annex 1. The buyout fee must be paid in full within
            thirty (30) days of providing the written notice of termination.
          </p>
        </Article>

        <Article n={6} title="Intellectual property" data-id="element-5935" data-mp="hinqrkkpgj2k">
          <p data-id="element-5936" data-mp="mb8imgk1wm3g">
            Nothing in the Partner Agreement will be interpreted or construed so
            as to transfer any right, title, or interest in any Intellectual
            Property Rights of a Party to the other Party.
          </p>
          <p data-id="element-5937" data-mp="va2bpwy6auc9">
            Giga, its licensors and/or its suppliers retain all Intellectual
            Property Rights to or in its services and any other software or
            materials provided or made available by Giga.
          </p>
          <p data-id="element-5938" data-mp="15fkept5y0oe5">
            Rights to or in any information made available by Partner to Giga is
            and remains vested in Partner (and/or its licensors).
          </p>
          <p data-id="element-5939" data-mp="10itvwy2r7ep1">
            Giga is entitled to mention Partner on its website(s) and in other
            promotional materials. To this end, Giga is entitled to use
            Partner&rsquo;s trade name, trademarks and logos.
          </p>
          <p data-id="element-5940" data-mp="1o7mmef0lwuc9">
            The Partner is granted the right to use relevant names and logos of
            Giga for the sole purpose of providing Referral Services. Giga can
            stipulate conditions for how these materials are used or reproduced,
            which the Partner must comply with strictly.
          </p>
        </Article>

        <Article n={7} title="Liability" data-id="element-5941" data-mp="2bya9i7j3fqje">
          <p data-id="element-5942" data-mp="274xo069pnzuv">
            Giga can only be liable towards Partner for direct damages as a
            result of an attributable failure in the performance of the Partner
            Agreement. Giga&rsquo;s liability for indirect damages is excluded.
            For the purposes of the Partner Agreement, indirect damages include
            lost savings, loss of data, loss of profit, damage to reputation and
            damage due to business interruption or stagnation.
          </p>
          <p data-id="element-5943" data-mp="39k8wpda7unmz">
            Without prejudice to the foregoing, Giga&rsquo;s liability for
            direct damages is limited to the amount (excluding VAT) of
            commission paid to Partner (if any) in the three (3) months prior to
            the damage-causing incident.
          </p>
          <p data-id="element-5944" data-mp="34kmib0inj1cl">
            The limitation of liability as referred to in the previous
            paragraphs of this Article 7 will lapse if and to the extent that
            the damage is the result of intent or deliberate recklessness on the
            part of Giga&rsquo;s management.
          </p>
          <p data-id="element-5945" data-mp="b7uj1hssfwpd">
            Any right to compensation is subject to the condition that Partner
            notifies Giga in writing of the damage within 30 days after
            discovery.
          </p>
        </Article>

        <Article n={8} title="Force majeure" data-id="element-5946" data-mp="k7ra1q2nh7nl">
          <p data-id="element-5947" data-mp="k6oh7clrov51">
            Neither Party can be obliged to perform any obligation under the
            Partner Agreement if such performance is prevented due to force
            majeure. Neither Party is liable for any loss and/or damage due to
            force majeure.
          </p>
          <p data-id="element-5948" data-mp="3jpqvsyev7xjl">
            Force majeure is considered to exist in any event in case of power
            outages, Internet failures, telecommunication infrastructure
            failures, network attacks (including D(DOS) attacks), attacks by
            malware or other harmful software, civil commotion, natural
            disaster, terror, mobilisation, war, import and export barriers,
            strikes, stagnation in supplies, fire, floods and any circumstance
            whereby a Party is not enabled to perform or prevented from
            performing by its suppliers, irrespective of the reason.
          </p>
        </Article>

        <Article n={9} title="Confidentiality" data-id="element-5949" data-mp="24plezry8dtig">
          <p data-id="element-5950" data-mp="24qd028u7c8uh">
            The Parties will treat as confidential and not disclose, except as
            expressly permitted herein, (i) the contents of the Partner
            Agreement and (ii) the information they provide to each other
            before, during or after the performance of the Partner Agreement if
            this information has been marked as confidential or if the receiving
            Party knows or should reasonably assume that this information was
            intended to be confidential. The Parties also impose this obligation
            on their employees and on the third parties engaged by them for the
            performance of the Partner Agreement.
          </p>
          <p data-id="element-5951" data-mp="ocms2qzyp0fk">This Article 9 will not apply to any information which:</p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-5952" data-mp="2zz6wox5w9qym">
            <li data-id="element-5953" data-mp="34x8nk49kaukn">
              is or becomes generally available to the public other than as a
              result of a disclosure by the receiving Party in breach of the
              Partner Agreement;
            </li>
            <li data-id="element-5954" data-mp="2v6x5zewygmva">
              was within the receiving Party&rsquo;s possession prior to its
              disclosure to it by or on behalf of the disclosing Party;
            </li>
            <li data-id="element-5955" data-mp="2m6qutzoqbyza">
              becomes available to the receiving Party on a non-confidential
              basis from a source other than the disclosing Party not under
              obligation to keep such information confidential; or
            </li>
            <li data-id="element-5956" data-mp="2c9319d2v0xip">is developed independently by the receiving Party.</li>
          </ul>
          <p data-id="element-5957" data-mp="6gxpg1fhswtj">
            In the event that a receiving Party becomes legally compelled to
            disclose any confidential information provided pursuant to the
            Partner Agreement, such receiving Party will provide the disclosing
            Party with prompt written notice so that disclosing Party may seek a
            protective order or other appropriate remedy and/or waive compliance
            with the confidentiality provisions of the Partner Agreement.
          </p>
          <p data-id="element-5958" data-mp="15ff0ndwl5bc1">
            Promptly after the expiration or termination of the Partner
            Agreement for any reason, each receiving Party will deliver to each
            disclosing Party all originals and copies of any material in any
            form containing or representing the confidential information in its
            possession or will destroy the same at the request of the disclosing
            Party.
          </p>
        </Article>

        <Article n={10} title="Amendments" data-id="element-5959" data-mp="2lsn0b0qw2f2o">
          <p data-id="element-5960" data-mp="2ltoma09g0lz6">
            Giga is at any time entitled to amend or supplement the Partner
            Agreement, these Affiliate Partner Terms, including Annex 1 and
            Annex 2, at any given moment. If Giga decides to amend the Partner
            Agreement, it will notify Partner of such amendments in writing.
            Amendments to the Partner Agreement will take effect two (2) weeks
            after Partner was notified. If Partner is not willing to accept an
            amendment, it may terminate the Partner Agreement by the date on
            which the amendment takes effect.
          </p>
        </Article>

        <Article n={11} title="Miscellaneous provisions" data-id="element-5961" data-mp="379t8zy58gya3">
          <ul className="list-disc pl-5 space-y-2" data-id="element-5962" data-mp="3c9yv6ysqhsks">
            <li data-id="element-5963" data-mp="3c8nu56qoayxd">This Agreement is governed exclusively by Dutch law.</li>
            <li data-id="element-5964" data-mp="3h2iiinh8422s">
              Any dispute between the Parties in connection with or rising from
              the Agreement will be submitted to the competent court in the
              Netherlands in the district where Giga has its registered office
              &ndash; unless the provisions of mandatory law dictate otherwise.
            </li>
            <li data-id="element-5965" data-mp="3he9e0okgness">
              Where the Agreement refers to &ldquo;written&rdquo; or &ldquo;in
              writing&rdquo;, this also includes communication by e-mail or via
              the Reditus platform, provided the identity of the sender and the
              integrity of the content can be adequately established.
            </li>
            <li data-id="element-5966" data-mp="3m617p7ywy0n5">
              The version of any communication of information as recorded by
              Giga will be deemed to be authentic unless Partner supplies proof
              to the contrary.
            </li>
            <li data-id="element-5967" data-mp="2ugobw06c2b2p">
              If any provision of the Agreement is found to be contrary to
              applicable law, or is otherwise unenforceable, this provision will
              be amended to the extent that it is in accordance with applicable
              law, with due observance of the intended meaning of the relevant
              provision.
            </li>
            <li data-id="element-5968" data-mp="io98b8ig6eex">
              Giga will be authorised to transfer the Partner Agreement or any
              of its rights and obligations arising therefrom to a third party
              without the consent of Partner. Partner will not be authorised to
              transfer the Partner Agreement or its rights and obligations
              arising therefrom to a third party without prior written
              permission from Giga.
            </li>
          </ul>
        </Article>

        {/* ── Annex 1 ─────────────────────────────────────────────────────── */}
        <section className="pt-6 border-t border-neutral-200" data-id="element-5969" data-mp="2oc8cewzijf8l">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-2 font-title" data-id="element-5970" data-mp="2akldepe6rsm4">
            Affiliate Partner Terms | Annex 1
          </h2>
          <p className="text-lg font-medium text-neutral-600 mb-6" data-id="element-5971" data-mp="2fimw397p9px2">
            Referral Services and Variable Term Sheet
          </p>

          <div className="space-y-8" data-id="element-5972" data-mp="33764doqr22p5">
            <div data-id="element-5973" data-mp="380hdjwj1avk8">
              <h3 className="text-lg font-semibold text-[#2B211A] mb-3" data-id="element-5974" data-mp="3810wngkf7pzu">
                1. Referral Service
              </h3>
              <p className="mb-3 font-medium text-neutral-600" data-id="element-5975" data-mp="3hv6hei4911zu">
                Type: &lsquo;Purchases by Leads&rsquo;
              </p>
              <p className="mb-3" data-id="element-5976" data-mp="37xs42rdmgtbr">
                Partner will receive a commission of{' '}
                <strong className="text-[#2B211A]" data-id="element-5977" data-mp="32yp7zwfmdxfx">20%</strong> of the total
                value, in euro as reported and calculated through the Reditus
                platform, of eligible purchases made by a Lead as a result of
                Partner&rsquo;s Referral Services, excluding discounts, VAT and
                any other applicable extra charges, during the period
                (hereinafter: &ldquo;Commission Period&rdquo;) specified under
                Term 6 below. A referral is attributed to Partner where the Lead
                purchases within{' '}
                <strong className="text-[#2B211A]" data-id="element-5978" data-mp="2fb78tfu0zx2x">90 days</strong> of clicking
                Partner&rsquo;s referral link (the referral cookie window).
              </p>
              <p className="mb-3" data-id="element-5979" data-mp="qop0xq22or30">
                &lsquo;Eligible purchases&rsquo; will be understood to mean the
                purchase or renewal of any of Giga&rsquo;s following products,
                subscriptions or services during the Commission Period:
              </p>
              <ul className="list-disc pl-5 space-y-2 mb-3" data-id="element-5980" data-mp="14o6tmgihoohn">
                <li data-id="element-5981" data-mp="71hnbugr7ppz">Giga subscription, any plan size.</li>
              </ul>
              <p className="mb-3" data-id="element-5982" data-mp="6zem0ea5ia5y">
                Partner will not be entitled to commission:
              </p>
              <ul className="list-disc pl-5 space-y-2 mb-3" data-id="element-5983" data-mp="by7xy29sht40">
                <li data-id="element-5984" data-mp="gyvs2wtbeq2g">
                  for the purchase by a Lead of products, subscriptions or
                  services that do not qualify as eligible purchases;
                </li>
                <li data-id="element-5985" data-mp="3kfcnavcfb2j1">
                  for purchases of eligible purchases by Leads who have turned
                  to Giga independently and directly without the intermediary
                  efforts of Partner, which, as a result, are not reported
                  through the Reditus platform;
                </li>
                <li data-id="element-5986" data-mp="2duwdq6gr66bz">
                  in case Giga has not received payment (including chargeback
                  events) of amounts due by the Lead for the eligible purchase;
                </li>
                <li data-id="element-5987" data-mp="2msf29ktlv2sm">
                  if the Lead is, or was, a customer of Giga prior to the moment
                  the Lead was referred by Partner through the Referral
                  Services;
                </li>
                <li data-id="element-5988" data-mp="2wq38p80kpyqm">
                  that is generated by Partner by fraudulent acts or acts in
                  violation of the Partner Agreement or applicable law;
                </li>
                <li data-id="element-5989" data-mp="36jtu241elt23">
                  other than the commission explicitly specified in the Partner
                  Agreement.
                </li>
              </ul>
              <p data-id="element-5990" data-mp="3fjqbbklgrpn4">
                The consequences of termination without cause by Giga, or
                termination by the Partner on the basis of Article 10, will be
                that the Partner will remain entitled to a commission under the
                Partner Agreement for the full agreed Commission Period for each
                Lead. In such an event, the amount of commission relating to
                each Lead owed to Partner in each remaining Payment Period after
                termination, will be assumed to be the average amount of
                commission accrued by the Partner under the Partner Agreement
                during the Payment Periods relating to that specific Lead before
                termination, unless Giga provides evidence to the contrary.
              </p>
            </div>

            <div data-id="element-5991" data-mp="3bca27lid2jbw">
              <h3 className="text-lg font-semibold text-[#2B211A] mb-3" data-id="element-5992" data-mp="2xf3nq34o76sh">
                2. Buyout Fee Calculation
              </h3>
              <p data-id="element-5993" data-mp="31fds5bctdp58">
                The buyout fee will be an amount equal to the average monthly
                commission earned by the Partner in the three (3) months prior
                to the termination date, multiplied by the remaining months in
                the Commission Period. If the Commission Period is less than
                three (3) months, the buyout fee will be calculated based on the
                average monthly commission earned during the actual months of
                the Commission Period.
              </p>
            </div>

            {/* Term sheet summary */}
            <div className="rounded-2xl border border-neutral-200 overflow-hidden" data-id="element-5994" data-mp="2cb1uwexju650">
              <dl className="divide-y divide-neutral-200" data-id="element-5995" data-mp="2h2tf87q43fmp">
                {[{
                term: '3. Commission Rate',
                value: '20% of eligible purchase value'
              }, {
                term: '4. Referral Cookie Window',
                value: '90 days'
              }, {
                term: '5. Payment Period',
                value: 'Up to 30 days'
              }, {
                term: '6. Commission Period',
                value: '12 months'
              }, {
                term: '7. Payment Threshold',
                value: '€50'
              }, {
                term: '8. Payment method',
                value: 'Stripe'
              }].map(row => <div key={row.term} className="grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-4 px-5 py-4" data-id="element-5996" data-mp="5g9c65ztux5r">
                    <dt className="text-sm font-semibold text-[#2B211A]" data-id="element-5997" data-mp="133rjdcdubr7n">
                      {row.term}
                    </dt>
                    <dd className="text-sm text-neutral-600" data-id="element-5998" data-mp="y4x2ifzfocq6">{row.value}</dd>
                  </div>)}
              </dl>
            </div>
          </div>
        </section>

        <section data-id="element-5999" data-mp="ofdhp4s5u8so">
          <p className="text-sm text-neutral-500 mt-6" data-id="element-6000" data-mp="odspvmx8d3yi">
            Operated by Tonic Labs Limited · Last updated: July 2026
          </p>
        </section>
      </div>
    </div>;
}